export default __webpack_public_path__ + "assets/json/83a186bd8132520c7d335f793f4c529d.json";